import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { ReportIdResponse } from './model/reports'

export const apiFetchReportId = async (
  tipoSujeto: number,
  tipoFacturacion: number,
  tipoCiclo: number,
  commodity: number
): Promise<ReportIdResponse> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/reports/ciclos/report-id`, {
    params: {
      tipoSujeto,
      tipoFacturacion,
      tipoCiclo,
      commodity
    }
  }).then(response => {
    return response.data
  })
}
